import { render, staticRenderFns } from "./scheme-center.vue?vue&type=template&id=46955539&scoped=true"
import script from "./scheme-center.vue?vue&type=script&lang=ts"
export * from "./scheme-center.vue?vue&type=script&lang=ts"
import style0 from "./scheme-center.vue?vue&type=style&index=0&id=46955539&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46955539",
  null
  
)

export default component.exports